import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEFAULT_MENU } from '~common/config/menu';
import { ROUTER_STATE } from '~common/config/constants';
import { AuthenticationService } from '~common/service/authentication.service';

@Component({
  selector: 'app-sider',
  templateUrl: './sider.component.html',
  styleUrls: ['./sider.component.scss']
})
export class SiderComponent implements OnInit {
  listMenu = [];
  userProfile: any;
  currentUrl = '';
  userRole: string = 'Admin'

  @Input() isCollapsed: boolean;

  constructor(private route: ActivatedRoute, private authService: AuthenticationService) { }

  ngOnInit() {
    this.currentUrl = this.route[ROUTER_STATE].snapshot.url;
    this.userProfile = this.authService.getProfile();
    this.setMenu();
  }

  setStatusSelected(link: string) {
    return link === this.currentUrl;
  }

  setStatusOpen(item: any) {
    return item.find(x => x.link === this.currentUrl);
  }

  setMenu() {
    const role = this.userProfile.isAdmin ? 'admin':'student'
    this.userRole = role
    this.listMenu = DEFAULT_MENU[role]
  }
}
